import Cookies from "js-cookie";

export default function saveOriginalTargetDestination({ to }) {
  Cookies.set("finalDestination", to.fullPath, {
    expires: 30 / (24 * 60), // 30 min
    path: "/",
  });
}
